// src/widgets/moderation/TopRiskyChannels/TopRiskyChannels.tsx
import React from 'react';
import { GetFlagsResponse, ITopChannel } from 'redux/reducers/moderation/types';
import { decodeRestriction } from 'untils/transformFlagCounts';
import { Badge } from '../Badge/Badge';
import { Card } from '../Card/Card';
import './TopRiskyChannels.scss';

type Props = {
  topChannels: Array<ITopChannel> | [];
  onOpenChannel: (channelId: number) => void;
  flags: GetFlagsResponse | null;
};

export const TopRiskyChannels: React.FC<Props> = ({ topChannels, onOpenChannel, flags }) => {
  console.log(topChannels);
  return (
    <Card className="md-channels" title="Top risky channels">
      {topChannels.length === 0 ? (
        <div className="md-channels__empty">No data.</div>
      ) : (
        <div className="md-channels__list">
          {topChannels.map((channel) => (
            <div key={channel.id} className="md-channels__item">
              <div className="md-channels__main">
                <button
                  className="md-channels__title"
                  type="button"
                  onClick={() => onOpenChannel(channel.id)}
                >
                  {channel.title}
                </button>

                <div className="md-channels__meta">
                  {channel.adult && <Badge text="Adult" variant="warning" />}
                  {channel.verified && <Badge text="Verified" variant="success" />}
                  {typeof channel.participant_count === 'number' && (
                    <Badge text={`${channel.participant_count} people`} variant="default" />
                  )}
                </div>

                <a
                  className="md-channels__link"
                  href={channel.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  {channel.link}
                </a>
              </div>

              <div className="md-channels__right">
                <div className="md-channels__total">{channel.violations_count}</div>
                <div className="md-channels__breakdown">
                  {(channel.restrictions ?? []).slice(0, 3).map((x) => (
                    <Badge
                      key={x.restriction}
                      text={
                        decodeRestriction(x.restriction, flags?.data ?? [])[0]?.description ||
                        `Restriction ${x.restriction}`
                      }
                      variant="default"
                    />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
